import { render, staticRenderFns } from "./QCheckboxGroup.vue?vue&type=template&id=3a985e83&"
import script from "./QCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./QCheckboxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports